import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@lib/api";
import { API_ROUTES, VACANCY_FORM_SOURCE } from "../constants";
import type { VacancyFormAnswerField } from "../types/VacancyTypes";

interface SubmitVacancyFormParams {
  formId: string;
  locale: string;
  form: VacancyFormAnswerField[];
}

interface SubmitVacancyFormResponse {
  success: true;
}

export const useSubmitVacancyForm = () => {
  return useMutation({
    mutationFn: async ({ formId, locale, form }: SubmitVacancyFormParams) => {
      const response = await apiClient.post<SubmitVacancyFormResponse>(
        API_ROUTES.vacancyForm(formId),
        {
          form,
          source: VACANCY_FORM_SOURCE,
          locale,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: { locale },
        }
      );
      return response.data;
    },
  });
};
